export default __webpack_public_path__ + "static/media/Telkari of the Cloudcleaver.9294dbe6.jpg";